var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Events',{staticClass:"mb-5",attrs:{"event-id":_vm.event_id},on:{"select":_vm.loadSales}}),_c('Table',{attrs:{"tickets":_vm.tickets,"loading":_vm.loading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }